/**
 * @generated SignedSource<<bd6bf868ab37f4b385a8945d659744bf>>
 * @relayHash 46f552cbc164e70ef5b6a465d63f2187
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d37f74ef8d6e6c2d02f319780a3256ecd050e611ebd2aee6b76e8ebae6c5a25

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentVersionHistoryFilter = {
  contentType: string;
};
export type useVersionHistoryContentVersionHistoryQuery$variables = {
  after?: string | null | undefined;
  contentId: string;
  filter: ContentVersionHistoryFilter;
};
export type useVersionHistoryContentVersionHistoryQuery$data = {
  readonly contentVersionHistory: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
      } | null | undefined;
      readonly contentId: string;
      readonly contentProperties: {
        readonly latest: {
          readonly externalVersionId: string | null | undefined;
          readonly versionContainsAIContent: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly number: number;
      readonly updatedTime: string;
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type useVersionHistoryContentVersionHistoryQuery = {
  response: useVersionHistoryContentVersionHistoryQuery$data;
  variables: useVersionHistoryContentVersionHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 30
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentVersionHistoryConnection",
    "kind": "LinkedField",
    "name": "contentVersionHistory",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentVersion",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "isActive"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "kind": "ScalarField",
            "name": "number"
          },
          {
            "kind": "ScalarField",
            "name": "updatedTime"
          },
          {
            "concreteType": "ContentProperties",
            "kind": "LinkedField",
            "name": "contentProperties",
            "plural": false,
            "selections": [
              {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "externalVersionId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "versionContainsAIContent"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "ContentVersionHistoryPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "hasPreviousPage"
          },
          {
            "kind": "ScalarField",
            "name": "startCursor"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useVersionHistoryContentVersionHistoryQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useVersionHistoryContentVersionHistoryQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "46f552cbc164e70ef5b6a465d63f2187",
    "id": "3d37f74ef8d6e6c2d02f319780a3256ecd050e611ebd2aee6b76e8ebae6c5a25",
    "metadata": {},
    "name": "useVersionHistoryContentVersionHistoryQuery",
    "operationKind": "query",
    "text": "query useVersionHistoryContentVersionHistoryQuery($contentId:ID!,$filter:ContentVersionHistoryFilter!,$after:String){contentVersionHistory(id:$contentId,after:$after,first:30,filter:$filter){nodes{author{id,isActive,displayName},contentId,number,updatedTime,contentProperties{latest{externalVersionId,versionContainsAIContent}}},pageInfo{hasNextPage,hasPreviousPage,startCursor,endCursor}}}"
  }
};
})();

(node as any).hash = "296aa31263754473c2bb2fd3016f2336";

export default node;
